<script setup>
import { defineProps } from "vue";
import { Head } from "@inertiajs/inertia-vue3";
// import HeaderAuditorio from "../Componentes/Cabecalho/AuditorioV2";
import { useDialogos } from "../Composables/useDialogos";
import AlertaAnalise from "../Componentes/AlertaAnalise";
import ReportaErros from "../Componentes/ReportaErros";
import useGlobals from "../Composables/useGlobals";
import { useLiveStore } from "@/Stores/liveStore";

useDialogos();

const { nomeLeiloeiro } = useGlobals();

defineProps({
    title: String,
    description: String,
});

const liveStore = useLiveStore();
</script>

<template>
    <Head>
        <title>{{ (title ? title + " - " : "") + nomeLeiloeiro }}</title>
        <meta name="description" :content="description" />
    </Head>
    <q-layout view="hHh lpR fFf">
        <q-page-container>
            <reporta-erros>
                <div
                    v-if="liveStore.link"
                    id="liveanchor"
                    style="z-index: 10"
                    :style="liveStore.style"
                >
                    <q-video
                        v-if="liveStore.link"
                        width="500px"
                        class="absolute-full"
                        :src="liveStore.link"
                    />
                </div>
                <slot></slot>
                <alerta-analise />
            </reporta-erros>
        </q-page-container>
    </q-layout>
</template>
